import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Importamos tu componente principal

// Buscamos el div con id="root" en el HTML
const root = ReactDOM.createRoot(document.getElementById('root'));

// Dibujamos tu App dentro de ese div
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);